
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

// Sample data - in a real app, this would come from an API
const patientGrowthData = [
  { month: 'Jan', newPatients: 8, returningPatients: 5 },
  { month: 'Feb', newPatients: 12, returningPatients: 6 },
  { month: 'Mar', newPatients: 15, returningPatients: 8 },
  { month: 'Apr', newPatients: 18, returningPatients: 10 },
  { month: 'May', newPatients: 16, returningPatients: 12 },
  { month: 'Jun', newPatients: 20, returningPatients: 15 },
];

const patientLocations = [
  { location: 'United States', count: 48, percentage: '32%' },
  { location: 'United Kingdom', count: 35, percentage: '24%' },
  { location: 'Germany', count: 22, percentage: '15%' },
  { location: 'France', count: 15, percentage: '10%' },
  { location: 'Australia', count: 10, percentage: '7%' },
  { location: 'Other', count: 18, percentage: '12%' },
];

const PatientAnalytics: React.FC = () => {
  return (
    <div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <h3 className="text-sm font-medium mb-3">Monthly Patient Growth</h3>
          <div className="h-[250px]">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                data={patientGrowthData}
                margin={{ top: 5, right: 20, left: 0, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="month" />
                <YAxis axisLine={false} tickLine={false} />
                <Tooltip />
                <Line 
                  type="monotone" 
                  name="New Patients"
                  dataKey="newPatients" 
                  stroke="#8884d8" 
                  strokeWidth={2}
                  activeDot={{ r: 6 }} 
                />
                <Line 
                  type="monotone"
                  name="Returning Patients"
                  dataKey="returningPatients" 
                  stroke="#82ca9d" 
                  strokeWidth={2}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
          <div className="flex justify-between mt-4 text-sm text-muted-foreground">
            <div className="flex items-center">
              <div className="w-3 h-3 rounded-full bg-[#8884d8] mr-2"></div>
              <span>New</span>
            </div>
            <div className="flex items-center">
              <div className="w-3 h-3 rounded-full bg-[#82ca9d] mr-2"></div>
              <span>Returning</span>
            </div>
            <div>
              <span className="font-medium text-primary">73%</span> New vs <span className="font-medium text-primary">27%</span> Returning
            </div>
          </div>
        </div>
        
        <div>
          <h3 className="text-sm font-medium mb-3">Patient Locations</h3>
          <div className="border rounded-lg overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Country
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Patients
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    % of Total
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {patientLocations.map((location, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    <td className="px-6 py-2 whitespace-nowrap text-sm font-medium text-gray-900">
                      {location.location}
                    </td>
                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                      {location.count}
                    </td>
                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                      {location.percentage}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientAnalytics;
